export default {
    props: {
        threshold: { type: Number, default: 1 },
        root: { type: [HTMLDivElement, null], default: null },
        rootMargin: { type: [String, Number], default: '0' },
    },
    mounted() {
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.handleIntersect(entry);
                    }
                });
            },
            {
                root: this.root,
                rootMargin: isNaN(this.rootMargin) ? this.rootMargin : `${this.rootMargin}px`,
                threshold: this.threshold,
            },
        );

        const isDomElement = this.$el instanceof HTMLElement;

        if (isDomElement) {
            this.observer.observe(this.$el);
        }

    },
    methods: {
        handleIntersect(entry) {
            this.$emit('intersected', entry, this.observer);
        },
    },
    destroyed() {
        this.observer.disconnect();
    },
    render() {
        return this.$slots.default[0];
    },
};
